import { createContext, useState, useEffect, useContext } from 'react';
// import { isAuthenticated as checkAuthStatus, getAuthenticatedUser, logout as apiLogout, login as apiLogin } from '../api/auth';
import { isAuthenticated as checkAuthStatus, getAuthenticatedUser, logout as apiLogout, login as apiLogin } from '../api/auth.sso';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const checkAuth = async () => {
    try {
      const isAuthenticatedStatus = checkAuthStatus();

      if (isAuthenticatedStatus) {
        const userData = await getAuthenticatedUser();
        setUser(userData);
        setIsAuthenticated(true);
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }
    } catch (err) {
      console.error('Ошибка проверки сессии:', err);
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const loginResult = await apiLogin(email, password);
      
      // apiLogin возвращает { token, id }, нам нужны полные данные пользователя с role
      // Вызываем getAuthenticatedUser для получения полных данных
      try {
        const userData = await getAuthenticatedUser();
        setUser(userData);
        setIsAuthenticated(true);
        return true;
      } catch (authError) {
        console.error('Ошибка проверки прав доступа после входа:', authError);
        // Если нет прав, удаляем данные из localStorage и возвращаем false
        const { removeAuthDataFromStorage } = await import('../api/auth.sso');
        removeAuthDataFromStorage();
        setUser(null);
        setIsAuthenticated(false);
        return false;
      }
    } catch (err) {
      console.error('Ошибка входа:', err);
      setUser(null);
      setIsAuthenticated(false);
      return false;
    }
  };

  const logout = async () => {
    try {
      await apiLogout();
    } catch (err) {
      console.error('Ошибка выхода:', err);
    } finally {
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAuthenticated, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;